module.exports = __webpack_public_path__ + "media/images/shared/ad/te-c9b5f643635ec4e9a4807d7116861e98.jpg";